import { render, staticRenderFns } from "./CourseSostav.vue?vue&type=template&id=95f578bc&"
import script from "./CourseSostav.vue?vue&type=script&lang=js&"
export * from "./CourseSostav.vue?vue&type=script&lang=js&"
import style0 from "@/assets/poliglotiki/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./CourseSostav.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports